exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cookies-not-supported.container{display:flex;align-items:center;justify-content:center;flex-direction:column;max-width:45%;margin:0 auto;height:100%}", ""]);

// exports
